import ExchangeControlsWrapper from './ui/ExchangeControlsWrapper/ExchangeControlsWrapper.css';

export default {
	ExchangeControlsWrapper
};
